module.exports = __webpack_public_path__ + "img/2.42a68489.jpg";